import React, { useEffect, useState } from 'react';
import { supportFetch, fmtNum } from '../api';
import ExportButton from '../components/ExportButton';

// S/N units per company. Each company lists its serials with a file count.
const SerialsTab = ({ token, onAuthFail }) => {
  const [companies, setCompanies] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    supportFetch('/support/serials', token, onAuthFail)
      .then(d => setCompanies(d.companies || []))
      .catch(e => { if (e.message !== 'Session expired') setError('Failed to load serials.'); })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <div className="sp-loading">Loading serials…</div>;
  if (error)   return <div className="sp-error">{error}</div>;

  const q = search.toLowerCase();
  const filtered = companies
    .map(c => ({
      ...c,
      serials: q
        ? c.serials.filter(s => `${c.display} ${s.serial}`.toLowerCase().includes(q))
        : c.serials,
    }))
    .filter(c => !q || c.serials.length || `${c.display}`.toLowerCase().includes(q));

  // Flatten for export
  const exportRows = companies.flatMap(c => c.serials.map(s => ({ company: c.display, companyKey: c.companyKey, serial: s.serial, files: s.files })));

  return (
    <div className="sp-serials">
      <div className="sp-toolbar">
        <input className="sp-search" placeholder="🔍 Search company or serial…" value={search} onChange={e => setSearch(e.target.value)} />
        <ExportButton rows={exportRows} name="serials" />
      </div>

      {filtered.length === 0 && <div className="sp-empty">No serials match.</div>}

      {filtered.map(c => (
        <div key={c.companyKey} className="sp-panel">
          <h3>{c.display} <span className="sp-muted">({c.serials.length} serial{c.serials.length !== 1 ? 's' : ''})</span></h3>
          {c.serials.length === 0 ? <p className="sp-muted">No serials registered.</p> : (
            <div className="sp-chips">
              {c.serials.map(s => (
                <span key={s.serial} className="sp-chip" title={`${s.files} file(s)`}>
                  {s.serial}<span className="sp-chip-count">{fmtNum(s.files)}</span>
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SerialsTab;
